import { FocusTrap } from "@mui/base";
import { Box } from "@mui/material";

import { MoodysThemeProvider } from "@moodys/federated";
import { useMenu } from "components/Menu/context";
import { useDrawerMaxWidth } from "styles";

import { MainMenuListItems } from "./components/MainMenuListItems/MainMenuListItems";
import { MenuDrawer } from "./components/MenuDrawer";
import { MenuStateIcon } from "./components/MenuStateIcon";
import { SubMenuListItems } from "./components/SubMenuListItems/SubMenuListItems";

export const Menu = () => {
  const { menuOpen, subMenuOpen } = useMenu();
  const drawerMaxWidth = useDrawerMaxWidth();

  return (
    <FocusTrap open={menuOpen} disableRestoreFocus>
      <Box>
        <MenuStateIcon />
        <MoodysThemeProvider colorPalette="default">
          <MenuDrawer
            menuListItems={<MainMenuListItems />}
            subMenuListItems={<SubMenuListItems />}
            drawerMaxWidth={drawerMaxWidth}
            menuOpen={menuOpen}
            subMenuOpen={subMenuOpen}
          />
        </MoodysThemeProvider>
      </Box>
    </FocusTrap>
  );
};
